import { BusinessType, BusinessTypeForUnionView } from '../api';

export type BusinessTypeUI = BusinessType & BusinessTypeForUnionView & { isVisible?: boolean };
